import { Elements } from "@stripe/react-stripe-js";
import { getStripe, stripeAppearance } from "../../utils/getStripe";
import { useTheme } from "../../store/use-theme";
import StripeNonMotoForm from "./stripe-non-moto-form";
import { PublicChase } from "./payment-page.constants";

interface IStripeNonMotoPaymentContainer {
  chase: PublicChase;
  clientSecret: string;
  onBack: () => void;
}

const StripeNonMotoPaymentContainer = ({
  chase,
  clientSecret,
  onBack,
}: IStripeNonMotoPaymentContainer) => {
  const { theme } = useTheme();

  return (
    <Elements
      options={{ clientSecret, appearance: stripeAppearance(theme) }}
      stripe={getStripe()}
    >
      <StripeNonMotoForm chase={chase} onBack={onBack} />
    </Elements>
  );
};

export default StripeNonMotoPaymentContainer;
